export const AddressLabelDisplayMapping = {
  unitNumber: 'Unit number',
  buildingName: 'Complex/building name',
  streetAddress: 'Street address',
  suburb: 'Suburb',
  city: 'City',
  province: 'Province',
  postalCode: 'Postal code'
};

export const installationAddressNullCheck = (address) => {
  const noNullAddress = [ ...address.address_components ];
  let newObj = {};
  noNullAddress.forEach((item) => {
    newObj[item.type] = item;
  });

  return newObj;
};